import { useChargeReceipt } from '@/api/hooks/useChargeReceipt'
import { useFetchBillingRecord } from '@/api/hooks/useFetchBillingRecord'
import { usePaymentPlans } from '@/api/hooks/usePaymentPlans'
import { StripeRoot } from '@/components/BillingPage/CardEntry/StripeRoot'
import { Account } from '@/components/BillingPage/Sections/Account'
import { AttentionNote } from '@/components/BillingPage/Sections/AttentionNote'
import { History } from '@/components/BillingPage/Sections/History'
import { Plans } from '@/components/BillingPage/Sections/Plans'
import { TabScreenHeader } from '@/components/TabScreenHeader'
import { colors } from '@/constants/colors'
import { needsPaymentAttention } from '@/features/home/homeTiles'
import { PageShell } from '@/ui/core/page-shell'
import { Screen } from '@/ui/core/screen'
import { VStack } from '@/ui/core/stack'
import { ActivityIndicator, View } from 'react-native'
import Images from '#/assets/images/image-map'

/**
 * Billing, top to bottom: anything that needs fixing, the membership and the card in one quiet
 * card, then two payment plans and two payments with a page for all of them. Tapping a payment
 * downloads its receipt to the share sheet; fetching it shows a small pill rather than blocking the tab.
 */
export default function BillingScreen() {
	const { billingRecord, isLoading } = useFetchBillingRecord()
	const { plans, isLoading: isLoadingPlans } = usePaymentPlans()
	const { download: downloadReceipt, isLoading: isLoadingReceipt } = useChargeReceipt()
	const attention =
		!isLoading &&
		!isLoadingPlans &&
		needsPaymentAttention(billingRecord ?? null, plans ?? null, new Date())

	return (
		<StripeRoot>
			<Screen preset="fixed" className="flex flex-1" safeAreaEdges={[]}>
				<PageShell photo={Images.BrandPhoto} contentClassName="pt-2">
					<TabScreenHeader />
					<VStack gap={20}>
						{attention && <AttentionNote />}
						<Account
							subscription={billingRecord?.subscription}
							primaryCard={billingRecord?.primaryCard}
							isLoading={isLoading}
						/>
						<Plans plans={plans} isLoading={isLoadingPlans} />
						<History
							charges={billingRecord?.charges}
							isLoading={isLoading}
							onReceipt={downloadReceipt}
							isDownloading={isLoadingReceipt}
						/>
					</VStack>
				</PageShell>
				{isLoadingReceipt && (
					<View
						pointerEvents="none"
						className="absolute bottom-8 left-0 right-0 items-center"
					>
						<View className="rounded-full bg-ink px-4 py-2">
							<ActivityIndicator size="small" color={colors.white} />
						</View>
					</View>
				)}
			</Screen>
		</StripeRoot>
	)
}
